import {collection, field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class BalanceTillBreakdownReportData extends ReportData<BalanceTillBreakdownReportData> {
    @field summary: boolean = false;
    @collection() groupBy: string[] = ["none"];
}
